export default __webpack_public_path__ + "static/media/SourceSansPro-Regular.f74389bd.woff2";